import React, { useEffect, useState, useContext } from "react";

import {
  Marker,
  useMap,
  Circle,
  Polyline,
  Polygon,
  Tooltip
} from "react-leaflet";

import * as _ from "lodash";

const blackOptions = { color: "black", fillColor: "black" };
const redOptiions = { color: "red" };

const MapReport = ({ positions = [], geofences = [], marker = null }) => {
  const map = useMap();
  const [bounds, setBounds] = useState([]);

  useEffect(() => {
    if((positions?.length ?? 0) == 0) return;
    
    console.log('positions', positions)
    let bounds = positions.filter((e) => { return e?.latitude && e?.longitude }).map((e) => [e?.latitude, e?.longitude]);
    console.log('bounds', bounds)
    
    if(bounds.length == 0) return;
    map.fitBounds(bounds);
    setBounds(bounds);
  }, [positions]);

  useEffect(() => {
    if (marker != null) map.setView(marker);
  }, [marker]);

  function CIRCLE(lat, lng, radio) {
    return { type: "circle", lat: lat, lng: lng, radio: radio };
  }

  function LINESTRING() {
    let R = { type: "line", area: [] };
    let A = _.chunk(arguments, 2);
    A.forEach(function (e) {
      R.area.push({ lat: e[0], lng: e[1] });
    });
    return R;
  }

  function POLYGON() {
    let R = { type: "polygon", area: [] };
    let A = _.chunk(arguments, 2);
    A.forEach(function (e) {
      if (isNaN(Number(e[0]))) {
        console.log(arguments);
        throw new Exception();
      }
      if (isNaN(Number(e[1]))) {
        console.log(arguments);
        throw new Exception();
      }
      R.area.push({ lat: e[0], lng: e[1] });
    });
    return R;
  }

  function generateArea(e, index) {
    const areaOptions = {
      color: "#696969",
      fillColor: "#696969",
      fillOpacity: 0.3,
    };
    let area = eval(
      e.area.replace("((", "(").replace("))", ")").split(" -").join(",-")
    );
    //area = eval(e.area.split(' -').join(',-'));
    console.log("area", area);
    if (area.type == "circle") {
      if(isNaN(area.lat) || isNaN(area.lng) || isNaN(area.radio)) return (<></>)
      return (
        <Circle
          key={index}
          center={[area.lat, area.lng]}
          radius={area.radio}
          pathOptions={areaOptions}
        >
          <Tooltip direction="bottom" offset={[0,0]} opacity={0.7} permanent>
            {e.name}
          </Tooltip>
        </Circle>
      );
    } else if (area.type == "line") {
      return (
        <Polyline
          key={index}
          text={e.name}
          pathOptions={areaOptions}
          positions={area.area}
        >
          <Tooltip direction="bottom" offset={[0,0]} opacity={0.7} permanent>
            {e.name}
          </Tooltip>
        </Polyline>
      );
    } else if (area.type == "polygon") {
      return (
        <Polygon
          key={index}
          tool={e.name}
          pathOptions={areaOptions}
          positions={area.area}
        >
          <Tooltip direction="bottom" offset={[0,0]} opacity={0.7} permanent>
            {e.name}
          </Tooltip>
        </Polygon>
      );
    }
  }

  return (
    <>
      { bounds.length > 0 && (
        <Polyline pathOptions={redOptiions} positions={bounds} />
      )}    

      {positions.map((item, index) => {
        if(isNaN(item.latitude) || isNaN(item.longitude)) return (<></>)
        return (<Circle
          key={index}
          center={[item.latitude, item.longitude]}
          pathOptions={blackOptions}
          radius={1}
        />)}
      )}

      {marker && <Marker position={marker}></Marker>}

      {geofences.map((item, index) => generateArea(item, index))}
    </>
  );
};

export default MapReport;
